import ApolloClientService from './apolloclient.service'

const service = new ApolloClientService()

class BillingService {
  // Get billing data for a specific patient and month
  getBillingData = (patientId, month, year) => {
    return new Promise((resolve, reject) => {
      service
        .getBillingData(patientId, month, year)
        .then((data) => {
          resolve(data)
        })
        .catch((err) => reject(err))
    })
  }
}

export default new BillingService()